import type { CreateTokenRequest, CreateTokenResponse, RegenerateTokenRequest, Token } from '../api-types/tokens';
import type { Builder } from './types';

const BASE_PATH = '/v1/user';

export const tokenEndpoints = (builder: Builder) => ({
  getTokens: builder.query<Token[], string>({
    query: (projectId) => ({
      url: `${BASE_PATH}/tokens`,
      method: 'GET',
      headers: { 'Project-Id': projectId },
      params: { projectId: projectId },
    }),
    providesTags: (result, error, projectId) => [{ type: 'Tokens', id: projectId }],
  }),
  createToken: builder.mutation<CreateTokenResponse, CreateTokenRequest>({
    query: (req) => ({
      url: `${BASE_PATH}/tokens`,
      method: 'POST',
      headers: { 'Project-Id': req.project_id },
      params: { projectId: req.project_id },
      body: req,
    }),
    invalidatesTags: (result, error, req) => [{ type: 'Tokens', id: req.project_id }],
  }),
  releaseToken: builder.mutation<boolean, { projectId: string; tokenId: string }>({
    query: ({ projectId, tokenId }) => ({
      url: `${BASE_PATH}/tokens/${tokenId}/release`,
      method: 'PATCH',
      headers: { 'Project-Id': projectId },
      params: { projectId: projectId },
    }),
    invalidatesTags: (result, error, { projectId, tokenId }) => [{ type: 'Tokens', id: projectId }],
  }),
  revokeToken: builder.mutation<boolean, { projectId: string; tokenId: string }>({
    query: ({ projectId, tokenId }) => ({
      url: `${BASE_PATH}/tokens/${tokenId}/revoke`,
      method: 'PATCH',
      headers: { 'Project-Id': projectId },
      params: { projectId: projectId },
    }),
    invalidatesTags: (result, error, { projectId, tokenId }) => [{ type: 'Tokens' }],
  }),
  regenerateToken: builder.mutation<
    CreateTokenResponse,
    { projectId: string; tokenId: string; req: RegenerateTokenRequest }
  >({
    query: ({ projectId, tokenId, req }) => ({
      url: `${BASE_PATH}/tokens/${tokenId}/regenerate`,
      method: 'PATCH',
      headers: { 'Project-Id': projectId },
      params: { projectId: projectId },
      body: req,
    }),
    invalidatesTags: (result, error, { projectId, tokenId }) => [{ type: 'Tokens', id: projectId }],
  }),
  deleteToken: builder.mutation<boolean, { projectId: string; tokenId: string }>({
    query: ({ projectId, tokenId }) => ({
      url: `${BASE_PATH}/tokens/${tokenId}`,
      method: 'DELETE',
      headers: { 'Project-Id': projectId },
      params: { projectId: projectId },
    }),
    invalidatesTags: (result, error, { projectId, tokenId }) => [{ type: 'Tokens', id: projectId }],
  }),
});
